import { render, staticRenderFns } from "./related-prompts-landing.view.vue?vue&type=template&id=7baab924&scoped=true"
import script from "./related-prompts-landing.view.vue?vue&type=script&lang=ts"
export * from "./related-prompts-landing.view.vue?vue&type=script&lang=ts"
import style0 from "./related-prompts-landing.view.vue?vue&type=style&index=0&id=7baab924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baab924",
  null
  
)

export default component.exports